<template>
  <span
    :class="`inline-flex items-center px-2 py-1 rounded-sm text-xs font-medium ring-1 ring-inset ${twBg} ${twText}`"
    :title="title"
  >
    {{ label }}</span
  >
</template>

<script>
export default {
  name: "BadgeDefault",
  components: {},
  props: {
    label: { type: String },
    title: { type: String },
    twBg: { type: String, default: "bg-slate-100 ring-slate-500/20" },
    twText: { type: String, default: "text-slate-700" },
  },
  data() {
    return {};
  },
};
</script>
